import { create } from "zustand";
import type { GuidesFiltersState, FilterStatusType, FilterTipoLocacion, DateType } from "@/shared/domain/types";

export const useGuidesFiltersStore = create<GuidesFiltersState>((set) => ({
  statusTypes: [],
  tiposLocacion: [],
  dateTypes: [],
  hasStatusTypes: false,
  hasTiposLocacion: false,
  hasDateTypes: false,
  setStatusTypes: (statusTypes: FilterStatusType[]) => 
    set({ statusTypes, hasStatusTypes: true }),
  setTiposLocacion: (tiposLocacion: FilterTipoLocacion[]) => 
    set({ tiposLocacion, hasTiposLocacion: true }),
  setDateTypes: (dateTypes: DateType[]) => 
    set({ dateTypes, hasDateTypes: true }),
}));

